/* スマホ向けのハンバーガーon/off event */
import * as $ from 'jquery';

// MEMO: スマホのハンバーガーを制御するためのボタン
$(document).on('click', '#toggleButton', () => {
  $('#mobile-menu').toggleClass('hidden');
});
